import { useCallback } from "react"

import { Collapse, IconButton, ListItem } from "@mui/material"

import { HelpOutlineRoundedIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./InfoItemButton.styled"

export const InfoItemButton = (props) => {

    const {
        children,
        className,
        disabled,
        endAdornments,
        icon,
        isOpen,
        label,
        onClick,
        selected,
        tooltipText,
    } = props

    const Icon = icon


    const displayList = !!(isOpen && children?.length)

    const onButtonClick = useCallback(() => {
        if (!disabled) {
            if (onClick) {
                onClick()
            }
        }
    }, [disabled, onClick])

    return (
        <div>
            <Styled.ListItemButton
                className={className}
                disableRipple={disabled}
                isDisabled={disabled}
                isSelected={!disabled && selected}
                onClick={onButtonClick}>
                {Icon ? <Icon color="objects/object-black" /> : null}
                <Styled.Label
                    disabled={disabled}
                    id="info-item-name"
                    paddingLeft={!!icon}
                    selected={selected}>
                    {label}
                </Styled.Label>
                {tooltipText &&
                    <Styled.Tooltip color="colors/gris/400" disableFocusListener title={tooltipText}>
                        <IconButton>
                            <HelpOutlineRoundedIcon />
                        </IconButton>
                    </Styled.Tooltip>
                }
                {endAdornments}
                {!!children?.length && !disabled && <Styled.ArrowIcon color="objects/object-placeholder" isOpen={isOpen} />}
            </Styled.ListItemButton>
            <Collapse in={displayList}>
                <Styled.List disablePadding>
                    {children}
                </Styled.List>
            </Collapse>
        </div>
    )
}

InfoItemButton.defaultProps = {
    selected: false,
}

InfoItemButton.propTypes = {
    ...ListItem.propTypes,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    disabled: PropTypes.bool,
    endAdornments: PropTypes.node,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    isOpen: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    selectedKey: PropTypes.bool,
    tooltipText: PropTypes.string,
}
